import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "section-title" };
const _hoisted_3 = { class: "text-muted" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "watch-lists" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "watch-lists__name" };
const _hoisted_9 = { class: "watch-lists__info" };
const _hoisted_10 = { class: "watch-lists__actions" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = { class: "watch-lists__name" };
import { ref, computed } from 'vue';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import events from "@astina/paloma-common-ui/src/services/EventBus";
import customers from "@astina/paloma-shop-common-ui/src/services/CustomerRepository";
import config from "../services/PortalConfig";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeWatchlists',
    setup(__props) {
        const watchlists = ref(null);
        const expanded = ref(false);
        const sharingEnabled = ref(config.watchlistsSharingEnabled);
        const sharingIcon = ref(config.watchlistsSharingIcon);
        loadWatchlists();
        events.$on([
            'command.save_watchlist.success',
            'command.add_watchlist_items.success',
            'command.delete_watchlist.success'
        ], loadWatchlists);
        function loadWatchlists() {
            customers.listWatchlists().then(w => {
                watchlists.value = w.sort((a, b) => new Date(b.modifiedAt ?? 0).getTime() - new Date(a.modifiedAt ?? 0).getTime());
            });
        }
        const sortedWatchlists = computed(() => watchlists.value || []);
        const visibleWatchlists = computed(() => {
            return expanded.value
                ? sortedWatchlists.value
                : sortedWatchlists.value.slice(0, 5);
        });
        function createWatchlist() {
            events.$emit('watchlists.open-create-form');
        }
        function openWatchlist(watchlist) {
            events.$emit('watchlists.open', watchlist);
        }
        function toggleExpanded() {
            expanded.value = !expanded.value;
        }
        function shareWatchList(watchlist) {
            events.$emit('watchlists.open-share', watchlist);
        }
        return (_ctx, _cache) => {
            return (watchlists.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("h3", _hoisted_2, [
                        _createVNode(Icon, {
                            name: "watch-list",
                            "icon-style": "duotone"
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('watchlist.my_lists')), 1)
                    ]),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('watchlist.info')), 1),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    (watchlists.value.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                            (_ctx.$isGranted('PORTAL_WATCHLISTS_MANAGE'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (createWatchlist()), ["prevent"])),
                                    class: "button button--outline",
                                    href: ""
                                }, [
                                    _createVNode(Icon, { name: "plus" }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('watchlist.create')), 1)
                                ]))
                                : (_openBlock(), _createElementBlock("em", _hoisted_5, _toDisplayString(_ctx.$t('watchlist.none')), 1))
                        ]))
                        : _createCommentVNode("", true),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_TransitionGroup, {
                            name: "expand",
                            tag: "div",
                            class: "watch-lists__container"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleWatchlists.value, (watchlist) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                        onClick: _withModifiers(($event) => (openWatchlist(watchlist)), ["prevent"]),
                                        href: "",
                                        key: watchlist.watchlistId,
                                        class: "watch-lists__item"
                                    }, [
                                        _createElementVNode("span", _hoisted_8, _toDisplayString(watchlist.name), 1),
                                        _cache[1] || (_cache[1] = _createTextVNode()),
                                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('watchlist.item_count', { count: watchlist.itemCount })), 1),
                                        _cache[2] || (_cache[2] = _createTextVNode()),
                                        _createElementVNode("span", _hoisted_10, [
                                            _createVNode(Icon, { name: "eye" })
                                        ]),
                                        _cache[3] || (_cache[3] = _createTextVNode()),
                                        (sharingEnabled.value)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "watch-lists__share",
                                                onClick: _withModifiers(($event) => (shareWatchList(watchlist)), ["prevent", "stop"])
                                            }, [
                                                _createVNode(Icon, { name: sharingIcon.value }, null, 8, ["name"])
                                            ], 8, _hoisted_11))
                                            : _createCommentVNode("", true)
                                    ], 8, _hoisted_7));
                                }), 128)),
                                _cache[4] || (_cache[4] = _createTextVNode()),
                                (sortedWatchlists.value.length > 5)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: "show-more-toggle",
                                        href: "",
                                        onClick: _withModifiers(toggleExpanded, ["prevent"]),
                                        class: "watch-lists__show-more"
                                    }, [
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(expanded.value ? _ctx.$t('watchlist.show-less') : _ctx.$t('watchlist.show-more')), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
